// extracted by mini-css-extract-plugin
export default {"range_input":"style_range_input__-Bh11"};